var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReports = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_8Tv73k",
    "data-name": "8Tv73k"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.41,23.86H4.64c-1,0-1.9-.75-1.9-1.79V1.93c0-.99.84-1.79,1.81-1.79h14.9c.97,0,1.81.8,1.81,1.79v20.14c0,.98-.83,1.79-1.85,1.79ZM19.49,23.11c.63-.08,1.03-.53,1.03-1.14V1.95c0-.65-.56-1.07-1.16-1.07H4.55c-.57,0-1.07.49-1.07,1.07v20.09c0,.65.56,1.07,1.16,1.07h14.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.2,6.04l-4.25,3.82c-.11.1-.43.03-.5-.07-.1-.14-.08-.4.07-.54l4.41-3.97c.13-.07.37-.08.48,0l3.36,2.52,3.58-3.93-1.64-.02c-.17-.03-.34-.2-.35-.36s.17-.38.34-.38h2.55c.14,0,.37.21.37.32v2.58c0,.17-.23.36-.4.35s-.34-.19-.34-.37l-.02-1.55-3.79,4.14c-.1.08-.35.12-.46.04l-3.42-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.34,13.72h-1.79c-.15,0-.36-.21-.38-.37v-5.24c0-.2.2-.41.39-.41h1.72c.19,0,.39.21.39.41v5.24c-.04.14-.19.3-.33.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.04,13.71h-1.67c-.23,0-.43-.2-.43-.44v-4.24c0-.31.23-.47.5-.47h1.61c.21,0,.4.24.4.46v4.14c0,.24-.08.54-.41.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.29,18.67H5.67c-.18,0-.35-.24-.34-.37,0-.19.18-.38.42-.38h12.51c.21,0,.38.15.41.31s-.1.44-.38.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.32,16.44H5.7c-.19,0-.38-.21-.38-.34,0-.21.16-.4.41-.4h12.52c.22,0,.37.16.41.33.03.13-.11.41-.35.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.69,13.71h-1.68c-.34,0-.46-.25-.46-.54v-2.8c.01-.17.24-.37.4-.37h1.67c.24,0,.44.21.44.46v2.82c0,.18-.17.43-.37.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.23,20.89H5.74c-.2,0-.38-.15-.41-.31s.13-.43.33-.43h8.54c.18,0,.37.16.4.29.04.17-.1.45-.36.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.49,13.72h-1.78c-.2-.01-.39-.25-.39-.44v-1.8c0-.18.21-.41.39-.41h1.73c.18,0,.39.23.39.41v1.81c0,.16-.16.37-.34.44Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReports);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reports.47166a5b1d99bb3bd0124da15bf96044.svg";